import { combineReducers } from 'redux'
import App from '~/views/app/redux/reducers/index'
import Auth from '~/views/auth/redux/reducers/index'
import Theme from '~/common/theme/redux/reducers'

const rootReducers = combineReducers({
  theme: Theme,
  app: App,
  auth: Auth,
})

export default rootReducers
